<template>
    <div style="height:100%" class="white">
        <table class="report-table white">

            <thead class="report-header">
                <tr>
                    <th class="print-only">
                        <!-- will print at the top of every page -->
                        <!-- this is a placeholder component - it is only here to give spacing on every printed page so that the actual site header has space - see: https://medium.com/@Idan_Co/the-ultimate-print-html-template-with-header-footer-568f415f6d2a -->
                        &nbsp;
                    </th>
                </tr>
            </thead>

            <tbody>
                <tr>
                    <td>
                        <v-progress-linear color="primary" indeterminate v-if="loading"></v-progress-linear>
                        <v-container v-else>
                            <v-row>
                                <v-col class="text-center">
                                    <span class="font-weight-bold text-h4">SPECIMEN {{specimen.SpecimenDisplayID}}</span>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="6">
                                    <span class="font-weight-bold">Species:</span> {{ specimen.SpeciesFullName }}
                                </v-col>
                                <v-col cols="6">
                                    <span class="font-weight-bold">Supplier:</span> {{ specimen.SupplierName }}
                                </v-col>
                                <v-col cols="6">
                                    <span class="font-weight-bold">Arrival Date:</span> {{ $moment.utc(specimen.ArrivalDate).format($constants.DATE_FORMAT_NO_TIME) }}
                                </v-col>
                                <v-col cols="6">
                                    <span class="font-weight-bold">Arrival Weight:</span> {{ specimen.ArrivalWeight }}
                                </v-col>
                                <v-col cols="6">
                                    <span class="font-weight-bold">Current Weight:</span> {{ specimen.CurrentWeight }}
                                </v-col>
                                <v-col cols="6">
                                    <span class="font-weight-bold">Location Type:</span> {{ specimen.LocationTypeText }}
                                </v-col>
                                <v-col cols="6">
                                    <span class="font-weight-bold">Room:</span> {{ specimen.RoomText }}
                                </v-col>
                                <v-col cols="6">
                                    <span class="font-weight-bold">Suite Number:</span> {{ specimen.SuiteNumberText }}
                                </v-col>
                                <v-col cols="6">
                                    <span class="font-weight-bold">Rack Number:</span> {{ specimen.RackNumber }}
                                </v-col>
                                <v-col cols="6">
                                    <span class="font-weight-bold">Drawer:</span> {{ specimen.DrawerText }}
                                </v-col>
                                <v-col cols="6">
                                    <span class="font-weight-bold">Geographical Location:</span> {{ specimen.GeographicalLocationName }}
                                </v-col>
                                <v-col cols="6">
                                    <span class="font-weight-bold">Deceased:</span> {{ specimen.Deceased ? "Yes" : "No" }}
                                </v-col>
                                <v-col cols="12">
                                    <span class="font-weight-bold">Miscellaneous Information:</span> 
                                    <p>{{ specimen.MiscellaneousInformation }}</p>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <span class="font-weight-bold text-h6">Venom Analysis</span>
                                    <PrintHistoricalAnalysis :venomAnalysis="venomAnalysis"></PrintHistoricalAnalysis>
                                </v-col>
                            </v-row>
                        </v-container>
                    </td>
                </tr>
            </tbody>

            <tfoot class="report-footer">
                <tr>
                    <td class="print-only">
                        <!-- will print at the bottom of every page -->
                        <!-- this is a placeholder component - it is only here to give spacing on every printed page so that the actual site footer has space - see: https://medium.com/@Idan_Co/the-ultimate-print-html-template-with-header-footer-568f415f6d2a -->
                        &nbsp;
                    </td>
                </tr>
            </tfoot>

            <!-- this will be fixed to the bottom of the page, and repeated on each printed page; to achieve the proper spacing, see: https://medium.com/@Idan_Co/the-ultimate-print-html-template-with-header-footer-568f415f6d2a -->
            <div class="print-footer-container print-only">
                Printed by {{name}} at {{$moment().format($constants.DATE_FORMAT)}}
            </div>

        </table>
    </div>
</template>

<script>
import util from '@/helpers/util';
import * as specimenAPI from "@/services/specimenAPI";
import * as venomAnalysisAPI from '@/services/venomAnalysisAPI';

import PrintHistoricalAnalysis from '@/components/venomanalysis/PrintHistoricalAnalysis.vue';

export default {
    components: {
        PrintHistoricalAnalysis
    },
    props: {
        specimenID: {
            type: [ Number, String ],
            default: null
        }
    },
    data() {
        return {
            loading: false,
            specimen: {},
            venomAnalysis: []
        }
    },
    computed: {
        name: function () {
            return util.getUserProfileNameFromUserObject(this.$store.state.authStore.user);
        }
    },
    async created() {
        this.loading = true;

        this.specimen = (await specimenAPI.getSpecimen({ SpecimenID: this.specimenID })).Specimens[0]
        this.venomAnalysis = await venomAnalysisAPI.getHistoricalAnalysis(this.specimenID, -1, -1, -1);

        this.loading = false;

        this.$nextTick(() => window.print());
    }
}
</script>

<style lang="scss">
#app {
    .report-table {
        width: 100%;
    }

    // this is a placeholder - if it is needed then we'll need to change the height
    .report-header th {
        height: 0px;
    }

    .report-footer td, .print-footer-container {
        height: 50px; // this reserves space for the actual footer, see: https://medium.com/@Idan_Co/the-ultimate-print-html-template-with-header-footer-568f415f6d2a
    }

    .print-footer-container {
        position: fixed;
        bottom: 0px;
        width: 100%;
        text-align: center;
        color: var(--v-lightgray-base);
    }
}

@media print {
    #app {
        // shade every second row
        .v-data-table__wrapper table tr:nth-child(2n) {
            background-color: var(--v-lightgray-lighten1)
        }
    }
}
</style>